import { useMutation } from '@tanstack/react-query'

import { FinanceService } from '../lib/finance.service'
import { FinancePayDTO } from '../lib/finance.types'

export const useFinancePay = () => {
  return useMutation({
    mutationFn: (params: FinancePayDTO) => {
      return FinanceService.makePayment(params)
    }
  })
}
